<script>
    import QuestionnaireDialog from "$/components/modals/QuestionnaireDialog.svelte";
    import { TokenStore } from "$/stores/TokenStore";
    import { onMount } from "svelte";
    import { EventService } from "$/services/EventService";

    let showQuestionnaireDialog = false;

    onMount(async () => {
        await TokenStore.init();
        var fixedCard = document.getElementById("js-fixed-card");
        var fixedCardClose = document.getElementById("js-fixed-card-close");

        fixedCardClose?.addEventListener("click", () => {
            fixedCard.style.display = "none";
        });

        EventService.trackEvent("extension-installed");

        // replace src of all images to absolute path so that they can be collected by the extension
        var images = document.querySelectorAll("img");
        images.forEach((image) => {
            let currentDomain = window.location.origin;
            image.src = image.src.replace("../", currentDomain);
        });

        showQuestionnaireDialog = !!!$TokenStore.user?.questionnaireDone;
    });
</script>

{#if showQuestionnaireDialog}
    <QuestionnaireDialog />
{/if}

<div class="page">
    <nav class="navigation">
        <img class="logo" src="../images/logo.svg" alt="logo" />
    </nav>

    <div class="container">
        <div class="flex min-h-screen flex-col">
            <section class="section-wrapper">
                <div class="section section--on-boarding">
                    <h1 class="on-boarding-title">How to use Collabwriting</h1>
                </div>
            </section>

            <div class="fixed-card" id="js-fixed-card">
                <div class="fixed-card--header">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="fixed-card--header-close"
                        id="js-fixed-card-close"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        stroke-width="2"
                    >
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                    <svg
                        width="85"
                        height="44"
                        class="fixed-card--header-icon"
                        viewBox="0 0 85 44"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M1.82812 24C1.82812 32.016 9.60558 38.5143 19.1996 38.5143C28.7935 38.5143 36.571 32.016 36.571 24C36.571 15.984 28.7935 9.48572 19.1996 9.48572C9.60558 9.48572 1.82812 15.984 1.82812 24Z"
                            fill="#FFFFC5"
                        />
                        <path
                            d="M2.8567 39.0857L5.48527 30.5143L11.6567 30.7429V36.8L2.8567 39.0857Z"
                            fill="#FFFFC5"
                        />
                        <path
                            d="M12.6715 22.8765C13.1421 22.8765 13.5478 23.015 13.8886 23.2921C14.2294 23.5528 14.3998 23.895 14.3998 24.3187C14.3998 24.5306 14.343 24.7995 14.2294 25.1254C14.132 25.4513 14.0022 25.7447 13.8399 26.0054C13.2557 26.9995 12.5173 27.7328 11.6247 28.2054C10.7322 28.678 9.62866 28.9143 8.31416 28.9143C6.80493 28.9143 5.49044 28.5476 4.37069 27.8143C3.25094 27.081 2.39084 26.038 1.79039 24.6854C1.20617 23.3328 0.914062 21.7602 0.914062 19.9676C0.914062 18.1913 1.20617 16.6513 1.79039 15.3476C2.37461 14.0439 3.21848 13.0499 4.322 12.3654C5.44176 11.6647 6.78059 11.3143 8.33851 11.3143C9.47449 11.3143 10.505 11.5017 11.43 11.8765C12.355 12.235 13.0772 12.7402 13.5965 13.3921C14.132 14.0276 14.3998 14.7447 14.3998 15.5432C14.3998 16.2602 14.1807 16.8469 13.7425 17.3032C13.3206 17.7595 12.7688 17.9876 12.0872 17.9876C11.3894 17.9876 10.8296 17.8002 10.4076 17.4254C9.98568 17.0343 9.77471 16.521 9.77471 15.8854C9.77471 15.5432 9.83962 15.2173 9.96945 14.9076C9.61243 14.6795 9.09312 14.5654 8.41153 14.5654C7.16196 14.5654 6.26129 14.9973 5.70952 15.861C5.15776 16.7084 4.88188 18.0528 4.88188 19.8943C4.88188 21.8173 5.1821 23.2595 5.78255 24.221C6.383 25.1825 7.31612 25.6632 8.58193 25.6632C9.18238 25.6632 9.68546 25.5328 10.0912 25.2721C10.4969 24.995 10.8458 24.5713 11.1379 24.001C11.3489 23.561 11.5598 23.2676 11.7708 23.121C11.998 22.958 12.2982 22.8765 12.6715 22.8765Z"
                            fill="black"
                        />
                        <path
                            d="M37.9207 19.5429C38.2766 19.5429 38.5597 19.6315 38.77 19.8087C38.9803 19.9698 39.0855 20.2356 39.0855 20.6061V21.6692C39.0855 22.0397 38.9803 22.3136 38.77 22.4908C38.5597 22.668 38.2766 22.7566 37.9207 22.7566H37.5567L34.135 35.6114C34.0703 35.8692 33.9247 36.0786 33.6982 36.2397C33.4717 36.3847 33.221 36.4572 32.9459 36.4572H31.0531C30.7619 36.4572 30.5031 36.3847 30.2766 36.2397C30.0663 36.0786 29.9207 35.8692 29.8398 35.6114L27.0976 26.9852L24.3555 35.6114C24.2746 35.8692 24.1209 36.0786 23.8944 36.2397C23.6679 36.3847 23.409 36.4572 23.1178 36.4572H21.2008C20.9257 36.4572 20.675 36.3847 20.4485 36.2397C20.222 36.0786 20.0764 35.8692 20.0117 35.6114L16.59 22.7566H16.226C15.8863 22.7566 15.6113 22.668 15.401 22.4908C15.1906 22.3136 15.0855 22.0397 15.0855 21.6692V20.6061C15.0855 20.2356 15.1906 19.9698 15.401 19.8087C15.6113 19.6315 15.8863 19.5429 16.226 19.5429H20.9096C21.2493 19.5429 21.5243 19.6315 21.7346 19.8087C21.9449 19.9698 22.0501 20.2356 22.0501 20.6061V21.6692C22.0501 22.0397 21.9449 22.3136 21.7346 22.4908C21.5243 22.668 21.2493 22.7566 20.9096 22.7566H20.5455L22.6568 31.0204L25.2776 22.8291C25.3585 22.5713 25.496 22.37 25.6901 22.225C25.8843 22.0639 26.1108 21.9834 26.3696 21.9834H28.5294C28.772 21.9834 28.9904 22.0639 29.1846 22.225C29.3787 22.37 29.5162 22.5713 29.5971 22.8291L32.1937 30.9238L34.2806 22.7566H33.9166C33.5607 22.7566 33.2776 22.668 33.0673 22.4908C32.857 22.3136 32.7518 22.0397 32.7518 21.6692V20.6061C32.7518 20.2356 32.857 19.9698 33.0673 19.8087C33.2776 19.6315 33.5607 19.5429 33.9166 19.5429H37.9207Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.7259 10.0073C16.8468 9.81524 18.0085 9.71429 19.1996 9.71429C24.7996 9.71429 29.7499 11.9458 32.8731 15.3848L33.1515 15.3513C29.9857 11.7919 24.915 9.48572 19.1996 9.48572C17.9727 9.48572 16.7755 9.59199 15.6204 9.79412L15.7259 10.0073Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M15.9575 11.359C15.3597 11.4614 14.7656 11.159 14.4967 10.6154L14.3912 10.4023C14.1995 10.0148 14.2017 9.55973 14.3971 9.17417C14.5925 8.78861 14.9582 8.51774 15.384 8.44322C16.6171 8.22742 17.8934 8.11429 19.1996 8.11429C25.2735 8.11429 30.729 10.5641 34.1763 14.4399C34.5155 14.8213 34.6149 15.3597 34.434 15.8371C34.2532 16.3145 33.8221 16.652 33.3152 16.7129L33.0368 16.7464C32.5959 16.7994 32.1565 16.6356 31.8579 16.3068C29.015 13.1765 24.4444 11.0857 19.1996 11.0857C18.086 11.0857 17.0018 11.1801 15.9575 11.359ZM32.8266 14.9974C29.6448 11.6398 24.7233 9.48572 19.1996 9.48572C18.247 9.48572 17.3124 9.54977 16.4015 9.67301C16.1618 9.70545 15.9237 9.74198 15.6874 9.78252C15.665 9.78635 15.6427 9.79022 15.6204 9.79412L15.7259 10.0073C16.8468 9.81524 18.0085 9.71429 19.1996 9.71429C24.7996 9.71429 29.7499 11.9458 32.8731 15.3848L33.1515 15.3513C33.1156 15.3109 33.0794 15.2706 33.0429 15.2305C32.9718 15.1522 32.8996 15.0745 32.8266 14.9974Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M11.1362 36.8593C12.7251 37.5563 14.4591 38.0537 16.2905 38.3117L15.4547 37.9444C14.1975 37.7111 12.9932 37.363 11.8583 36.914L11.1362 36.8593Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.80555 36.5273C9.96736 35.8787 10.5732 35.4413 11.2398 35.4918L11.9619 35.5465C12.0994 35.5569 12.2345 35.588 12.3627 35.6387C13.4148 36.0549 14.5338 36.3787 15.7049 36.5959C15.8087 36.6152 15.9099 36.6464 16.0065 36.6888L16.8423 37.0561C17.4694 37.3317 17.797 38.0278 17.6096 38.6867C17.4223 39.3456 16.7775 39.7652 16.0992 39.6697C14.1454 39.3944 12.2903 38.8631 10.5853 38.1152C9.97312 37.8467 9.64373 37.1759 9.80555 36.5273ZM16.2905 38.3117L15.4547 37.9444C14.1975 37.7111 12.9932 37.363 11.8583 36.914L11.1362 36.8593C11.3465 36.9515 11.5593 37.0403 11.7746 37.1254C11.7965 37.1341 11.8184 37.1427 11.8403 37.1513C12.9543 37.5872 14.1328 37.9272 15.3606 38.1587C15.3781 38.162 15.3956 38.1652 15.4132 38.1685C15.7029 38.2223 15.9955 38.2701 16.2905 38.3117Z"
                            fill="black"
                        />
                        <path
                            d="M4.79936 32.8C2.7813 41.1895 0.168829 41.1809 11.0099 36.8467C0.168829 41.1809 2.75381 41.3038 4.79936 32.8Z"
                            fill="black"
                        />
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M5.1201 31.4666C5.85651 31.6437 6.30989 32.3843 6.13275 33.1207C5.67358 35.0296 5.1856 36.5236 4.83292 37.6035C4.79607 37.7163 4.76071 37.8245 4.727 37.9283C5.33666 37.6934 6.06698 37.3906 6.97352 37.0147C7.93091 36.6177 9.08484 36.1393 10.5008 35.5732C11.2041 35.2921 12.0021 35.6343 12.2833 36.3376C12.5645 37.0409 12.2223 37.8389 11.519 38.1201C10.1086 38.6839 8.86909 39.2005 7.83654 39.6309C6.96022 39.9961 6.23302 40.2991 5.67706 40.5162C5.0518 40.7603 4.48377 40.9619 4.01396 41.0572C3.77891 41.1049 3.48185 41.145 3.16991 41.1104C2.83887 41.0737 2.40943 40.9412 2.06488 40.5683C1.73109 40.2071 1.63323 39.788 1.60795 39.4954C1.58312 39.2079 1.61782 38.9326 1.65801 38.7131C1.67715 38.6086 1.70115 38.4989 1.72898 38.3849C1.81752 38.0108 1.94976 37.5896 2.08895 37.1592C2.13724 37.0098 2.18826 36.8538 2.24159 36.6907C2.59177 35.6197 3.04122 34.245 3.46596 32.4793C3.6431 31.7428 4.38368 31.2895 5.1201 31.4666ZM11.0099 36.8467C5.6276 38.9985 3.56141 40.0841 3.09221 39.6052C2.94782 39.4578 2.95468 39.1622 3.06268 38.7039C3.32296 37.6427 4.09329 35.7353 4.79936 32.8C4.09155 35.7425 3.31061 37.6519 3.06268 38.7039C2.94405 39.1876 2.93138 39.4955 3.07905 39.6448C3.54602 40.1169 5.61641 39.0029 11.0099 36.8467Z"
                            fill="black"
                        />
                        <path
                            d="M49 25.5C59 27 79.5 24.5 78.5 2.5"
                            stroke="black"
                            stroke-width="3"
                            stroke-linecap="round"
                        />
                        <path
                            d="M72 8L78.5 2L83.5 8"
                            stroke="black"
                            stroke-width="3"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                        />
                    </svg>
                </div>
                <div class="fixed-card--content">
                    <h2 class="fixed-card--content-title">
                        Pin Collabwriting for easy access
                    </h2>
                    <p class="fixed-card--content-text">
                        You can pin Collabwriting from the <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="fixed-card--content-puzzle"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                        >
                            <path
                                d="M10 3.5a1.5 1.5 0 013 0V4a1 1 0 001 1h3a1 1 0 011 1v3a1 1 0 01-1 1h-.5a1.5 1.5 0 000 3h.5a1 1 0 011 1v3a1 1 0 01-1 1h-3a1 1 0 01-1-1v-.5a1.5 1.5 0 00-3 0v.5a1 1 0 01-1 1H6a1 1 0 01-1-1v-3a1 1 0 00-1-1h-.5a1.5 1.5 0 010-3H4a1 1 0 001-1V6a1 1 0 011-1h3a1 1 0 001-1v-.5z"
                            />
                        </svg> icon
                    </p>
                </div>
            </div>

            <section class="section-wrapper">
                <div class="section section--on-boarding">
                    <div class="block--on-boarding block">
                        <h2 class="title title--on-boarding">01.</h2>
                        <img
                            class="on-boarding-image"
                            src="../images/tut01.png"
                            alt="Arrow pointing to Collabwriting icon in the Chrome Extension bar"
                        />
                        <p class="on-boarding-text">
                            Click the Collabwriting icon in the Chrome Extension
                            bar (top right) to start &#128568;
                        </p>
                    </div>
                    <div class="block--on-boarding block">
                        <h2 class="title title--on-boarding">02.</h2>
                        <img
                            class="on-boarding-image"
                            src="../images/tut02.png"
                            alt="Collabwriting extension"
                        />
                        <p class="on-boarding-text">
                            Create a new Topic to collect Snippets from
                            different pages &#127873;
                        </p>
                    </div>
                    <div class="block--on-boarding block">
                        <h2 class="title title--on-boarding">03.</h2>
                        <img
                            class="on-boarding-image"
                            src="../images/tut03.gif"
                            alt="Text selection example"
                        />
                        <p class="on-boarding-text">
                            Select a piece of text and create a Snippet in this
                            Topic &#128064;
                        </p>
                        <p class="on-boarding-text">
                            You can also make the snippet by just pressing Enter
                            &#128161;
                        </p>
                    </div>
                    <div class="block--on-boarding block">
                        <h2 class="title title--on-boarding">04.</h2>
                        <img
                            class="on-boarding-image"
                            src="../images/tut04.png"
                            alt="How to find your shareable link"
                        />
                        <p class="on-boarding-text">
                            Your shareable link will be generated at the bottom
                            of the page &#128640;
                        </p>
                        <p class="on-boarding-text">
                            To open the Topic in the Dashboard just click the
                            Dashboard Icon to the right &#128516;
                        </p>
                    </div>
                </div>
            </section>
        </div>
    </div>

    <footer class="footer">
        <p>Made with &#128155; by Collabwriting Team</p>
        <p>
            Copyrights &copy; {new Date().getFullYear()} Collabwriting
        </p>
    </footer>
</div>

<style>
    body {
        --tw-bg-opacity: 1;
        background-color: rgb(245 245 245 / var(--tw-bg-opacity));
        font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
        scroll-behavior: smooth;
    }

    body,
    footer,
    nav,
    h1,
    h2,
    h3,
    p {
        margin: 0px;
        padding: 0px;
        box-sizing: border-box;
    }

    .page {
        min-height: 100vh;
        min-width: 100%;
        height: 100%;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        scroll-behavior: smooth;
    }

    .navigation {
        width: 100%;
        max-width: 1280px;
        padding: 2rem /* 32px */;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    /* Medium screens */
    @media (min-width: 640px) {
        .navigation {
            align-items: baseline;
        }
    }

    .logo {
        max-height: 2rem /* 32px */;
    }

    .container {
        margin-top: auto;
        margin-bottom: auto;
    }

    .footer {
        width: 100%;
        text-align: center;
        --tw-bg-opacity: 1;
        background-color: rgb(0 0 0 / var(--tw-bg-opacity));
        --tw-text-opacity: 1;
        color: rgb(255 255 255 / var(--tw-text-opacity));
        font-weight: 300;
        font-size: 0.875rem /* 14px */;
        line-height: 1.25rem /* 20px */;
        padding: 2rem /* 32px */;
    }

    .title {
        font-size: 2.5em;
        margin-bottom: 0.75em;
        font-weight: 300;
    }
    .title--on-boarding {
        font-weight: bold;
    }

    .section-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;

        width: calc(100% - 4rem);
        padding: 0 2rem;
    }
    @media (max-width: 640px) {
        /* Small screens */
        .section-wrapper {
            width: calc(100% - 16px);
            padding: 0 8px;
        }
    }

    .section-wrapper--footer {
        background: #455a64;
    }

    .section {
        width: 100%;
        max-width: 1100px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }

    .section--on-boarding {
        align-items: baseline;
        justify-content: left;
        padding: 3em 0em;
        gap: 3em;
    }
    @media (max-width: 640px) {
        /* Small screens */
        .section--on-boarding {
            justify-content: center;
        }
    }

    .section--footer {
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 3em 0.5em;
        background: #455a64;
        color: #fff;
    }
    .footer-made-by {
        font-size: 1.3em;
        margin-bottom: 1em;
    }

    .on-boarding-title {
        font-size: 3.5em;
        line-height: 100%;
        font-weight: bold;
        max-width: 350px;
    }
    @media (max-width: 640px) {
        /* Small screens */
        .on-boarding-title {
            text-align: center;
            max-width: 100%;
        }
    }
    .on-boarding-image {
        width: 350px;
        border-radius: 20px;
        box-shadow: 0px 5px 5px rgb(0 0 0 / 15%);
        margin-bottom: 20px;
        transition: all 0.3s;
    }
    .on-boarding-image:hover {
        transform: scale(1.05);
        box-shadow: 0px 10px 20px rgb(0 0 0 / 15%);
    }
    .on-boarding-text {
        width: 350px;
        margin-top: 16px;
        font-size: 1em;
        line-height: 1.3;
    }
    .on-boarding-text b {
        font-weight: bold;
    }

    .fixed-card {
        position: fixed;
        top: 30px;
        right: 100px;
        background: #fff;
        border-radius: 15px;
        box-shadow: 0px 5px 5px rgb(0 0 0 / 15%);
        padding: 15px;
        transition: all 0.3s;
    }
    .fixed-card:hover {
        transform: scale(1.05);
        box-shadow: 0px 10px 20px rgb(0 0 0 / 15%);
    }
    .fixed-card--header {
        display: flex;
        justify-content: space-between;
    }
    .fixed-card--header-close {
        width: 24px;
        height: 24px;
        color: #989d9f;
        cursor: pointer;
    }
    .fixed-card--header-close:hover {
        color: #000;
    }
    .fixed-card--content-title {
        font-weight: bold;
        font-size: 1.3em;
        margin-top: 15px;
        margin-bottom: 8px;
    }
    .fixed-card--content-text {
        font-size: 1em;
        line-height: 30px;
        display: flex;
    }
    .fixed-card--content-puzzle {
        width: 30px;
        margin: 0px 3px;
    }
    ::-webkit-scrollbar {
        width: 12px;
        height: 12px;
    }

    ::-webkit-scrollbar-thumb {
        background: #0002;
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #0003;
    }
</style>
